export const environment = {
  production: false,
  keycloak: {
    url: 'https://login26.dev.digitalware.rs',
    realm: 'otpad-i-hemikalije',
    clientId: 'otpad-i-hemikalije-portal',
  },
};
